export const VELO_BANNER_DEFAULT = {
  displayVeloBanner: false,
  prompt: null,
  message: '',
};

export const VELO_CTA_DEFAULT = {
  displayVeloCta: false,
  promptMessageId: null,
  topic: null,
};
